import React from "react";
import Header from "shared/components/Header/Header";
import {Outlet} from "react-router-dom";

export const AppShell = () => {
    console.log('6. AppShell rendering');
    return (
        <div className="home-page">
            <Header logOut={true} help={true}/>
            <Outlet />
        </div>
    );
}
